import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { KeychainItem } from '../KeychainItem';
import { Member } from '../members/Member';
/**
 * Equivalent of KeychainedResponse, but this one is patchable and used by the patchusermembers endpoint
 */
export class KeychainedMembers extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Create or update the keychain items for these public keys (needs to be also present in addMembers or updateMembers)
         */
        this.keychainItems = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(Member) })
], KeychainedMembers.prototype, "members", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(KeychainItem), optional: true })
], KeychainedMembers.prototype, "keychainItems", void 0);
//# sourceMappingURL=KeychainedMembers.js.map